"use client";

import { useState } from "react";

export default function MagazineNewsletter({ publicationName, sidebar = false }) {
  const [state, setState] = useState("idle");
  async function subscribe(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const email = new FormData(form).get("email");
    setState("loading");
    try {
      const response = await fetch("/api/newsletter/subscribers", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }),
      });
      setState(response.ok ? "success" : "error");
      if (response.ok) form.reset();
    } catch { setState("error"); }
  }
  return <section className="mag-newsletter" aria-label="Newsletter">
    <h3 className="mag-footer-title">{sidebar ? "Sign up" : "Stay informed"}</h3>
    <p>{sidebar ? "Get the latest headlines and our most-read stories delivered straight to your inbox. Enter your email to subscribe—we’ll take care of the rest." : `Get the best of ${publicationName} delivered to your inbox.`}</p>
    <form className="mag-newsletter-form" onSubmit={subscribe}>
      <input className="mag-newsletter-input" name="email" type="email" required aria-label="Email address" placeholder="Email address" />
      <button className="mag-button" disabled={state === "loading"}>{state === "loading" ? "…" : "Join"}</button>
    </form>
    {state === "success" && <p role="status">You’re subscribed.</p>}
    {state === "error" && <p role="alert">Subscription failed. Please try again.</p>}
  </section>;
}
